import { render, staticRenderFns } from "./SeasonsList.vue?vue&type=template&id=4c652a17&"
import script from "./SeasonsList.vue?vue&type=script&lang=js&"
export * from "./SeasonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports